import React, { useState, Fragment } from "react";
import StaticHead from "components/Static/Head";
import Link from "next/link";
import DocsNav from "components/Docs/Nav";
import Overlay from "components/Overlay";
import HoverIconButton from "components/HoverIconButton";
import DiscordLink from "components/DiscordLink";
import Nav from "components/Nav";
import BrandIcon from "components/Icons/brand";
import Pill from "components/Pill";
import Trigger from "components/Trigger";
import { STATUS, UI_THEME } from "utils/constants/ui";
import { CURRENT_VERSION_LABEL } from "utils/constants/version";
import ZoneLink from "components/ZoneLink";
import { getIconForUID } from "components/FormerEditor/utils";
import { COLORS } from "utils/styles";
import { showDocsModal } from "utils/docs";
import { getConfig } from "utils/env";
import PATHS from "utils/paths";
import { getJWT } from "utils/auth";

const MENU_WIDTH = 240;

const SIDEBAR_STYLES = {
  position: "fixed",
  top: 0,
  left: 0,
  // marginTop: 52,
  display: "flex",
  flexDirection: "column",
  width: MENU_WIDTH,
  minWidth: MENU_WIDTH,
  height: "100%",
  maxHeight: "100vh"
};

const SIDEBAR_NAV_STYLES = {
  flex: "1 1 0%",
  overflowY: "auto",
  marginBottom: "10px"
};

const CONTAINER_STYLES = {
  left: MENU_WIDTH
};

const StaticContainer = ({ meta, index, show, children, navConfig }) => {
  const [showOverlay, setShowOverlay] = useState(false);
  const jwtVal = getJWT();
  const showDocsMenu = () => setShowOverlay(true);
  const hideDocsMenu = () => {
    setShowOverlay(false);
  };

  const navMenu = <DocsNav onClick={hideDocsMenu} config={navConfig} />;

  const indexLink = (
    <div className="flex flex-column pa3 bb hairline-1">
      <div className="w-100 flex flex-row items-center">
        <ZoneLink href={jwtVal ? PATHS.HUB : PATHS.HOME}>
          <div
            style={{ height: 40 }}
            className="f4 pointer link__decoration--hover fw6"
          >
            <div className="flex flex-row items-center">
              <div className="flex-shrink-0">
                <BrandIcon />
              </div>
            </div>
          </div>
        </ZoneLink>
        <Pill theme={UI_THEME.SLIM} copy={CURRENT_VERSION_LABEL} />
      </div>
      <div className="flex flex-row bt hairline-1 pt3 mt3 w-100 justify-between">
        <Link key="indexLink" asPath={index.path} href={index.path}>
          <HoverIconButton
            customClasses={{
              button:
                "ma0 items-center flex pa0 dib items-center justify-center bn br1 panel--action relative"
            }}
            color={COLORS.blue}
            type="home"
            size={22}
          />
        </Link>
        <Trigger copy="Search" onClick={showDocsModal} />
      </div>
    </div>
  );

  const footerLabel = (
    <div className="pa3 bt hairline-1 flex items-center justify-center">
      <DiscordLink />
    </div>
  );

  return (
    <Fragment>
      <StaticHead meta={meta} />
      <div id="skip" className="db dn-l">
        <Nav />
      </div>
      <main id="skip" className="dn db-l">
        <div
          className="absolute top-0 left-0 bottom-0 right-0 bg-white bh--inset z-1"
          style={SIDEBAR_STYLES}
        >
          {indexLink}
          <nav className="docs--nav__desktop" style={SIDEBAR_NAV_STYLES}>
            {navMenu}
          </nav>
          {footerLabel}
        </div>
        <div
          className="absolute top-0 right-0 right-0 bottom-0 overflow-y-scroll overflow-x-hidden"
          style={CONTAINER_STYLES}
        >
          {children}
        </div>
      </main>
      <main id="skip" className="flex flex-column dn-l ph3 pt5">
        <div
          className="flex flex-row items-center pt3 mw7 justify-start"
          onClick={showDocsMenu}
        >
          <HoverIconButton type="list" />
          <div className="f6 pl2 fw5">{show.label}</div>
        </div>
        {children}
      </main>
      {showOverlay && (
        <Overlay hideOverlay={() => setShowOverlay(false)}>
          <div className="pt3">
            {indexLink}
            <nav className="docs--nav__mobile">{navMenu}</nav>
            {footerLabel}
          </div>
        </Overlay>
      )}
    </Fragment>
  );
};

export default StaticContainer;
